<template>
    <div class="header-wrapper">
        <div class="header">
          <img id="logo" :src="this.img()"/>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'Header',
    props: ['img'],
  }
</script>
<style>
    .header {
        margin: auto;
        width: 215px;
        padding: 40px 10px;
    }
</style>
